import { Bundle, BundleTube, SentinelBundleTube } from '../../models/bundle';
import { getRootTube } from './bundleParserHelpers';

/** A collection of utility functions for converting parsed bundle data into a shape that can be used for drawing the chart and uploading a bundle to the controller. */
export class BundleTranslator {
  public static readonly transformTubes = (bundle: Bundle): SentinelBundleTube[] => {
    // Triangle Sentinel mappings not supported by D3.
    if (!bundle?.tubes || bundle.tubes.length === 0) {
      return [];
    }

    return this.transformTubesFromPattern(bundle.tubes, bundle.pattern, bundle.rotated);
  };

  public static transformTubesFromPattern(
    tubes: BundleTube[],
    pattern: 'triangle' | 'square' | undefined,
    isRotated: boolean,
  ): SentinelBundleTube[] {
    if (!tubes?.length || !pattern) {
      return [];
    }

    const rootTube = getRootTube(tubes);

    if (pattern === 'square' && !isRotated) {
      // Set "root" measurements: row 1, and column based on Y
      const vNotR = 1; // This means rootTube.yCoordinate is the root of Vr-not = 1
      const vNotC = rootTube.xCoordinate; // Cartesian Y coordinate is 0-base index, column is 1-base indexed

      return tubes.map(tube => {
        const vR = rootTube.yCoordinate + 1 - tube.yCoordinate;
        const vC = tube.xCoordinate;

        const conversion: SentinelBundleTube = {
          ...tube,
          row: (vC - vNotC) / 2,
          column: vNotR - vR,
        };

        return conversion;
      });
    }

    // Get root tube row/column
    const spreadsheetRow0 = -rootTube.yCoordinate;
    const spreadsheetColumn0 = rootTube.xCoordinate;
    return tubes.map(tube => {
      const spreadsheetRow = -tube.yCoordinate;
      const spreadsheetColumn = tube.xCoordinate;

      // Convert from spreadsheet row/column to Sentinel row/column
      const conversion: SentinelBundleTube = {
        ...tube,
        row: (spreadsheetColumn + spreadsheetRow - (spreadsheetColumn0 + spreadsheetRow0)) / 2,
        column: spreadsheetRow0 - spreadsheetRow,
      };

      return conversion;
    });
  }
}
